<template>
    <div class="actions-list__action documents-action">
        <b-dropdown
            variant="link"
            no-caret
            class="documents-action__dropdown"
            toggle-class="documents-action__toggle btn btn--text btn--action"
            data-cy="actions-list-documents"
            aria-label="document action"
        >
            <template slot="button-content">
                <i class="actions-list__action-icon documents-action__action-icon fas fa-paperclip" />
                <span class="actions-list__action-count documents-action__action-count" data-jest="count">
                    {{ documents.length }}
                </span>
            </template>
            <!-- Document items -->
            <b-dropdown-item
                v-for="(document, index) in documents"
                :key="index"
                :href="document.type === 'document' ? document.original_url : null"
                :target="document.type === 'document' ? '_blank' : null"
                @click.prevent="handleClick(document)"
                data-jest="document"
            >
                <i
                    class="documents-action__dropdown-icon fas"
                    :class="document.type === 'audio' ? 'fa-microphone' : 'fa-file-pdf'"
                />
                <span class="documents-action__dropdown-label" data-jest="filename">
                    {{ document.original_name }}
                </span>
            </b-dropdown-item>
        </b-dropdown>

        <!-- Audio Modal -->
        <modal-component
            :show="selectedAudio"
            data-jest="audio-modal" @close="selectedAudio = false">
            <template slot="title">
                <div v-if="selectedAudio">
                    <p>{{ selectedAudio.original_name }}</p>
                </div>
            </template>
            <template slot="content">
                <div v-if="selectedAudio" class="audio-modal-content">
                    <audio
                        :src="selectedAudio.original_url"
                        controls
                    />
                </div>
            </template>
            <button class="btn btn--text" @click="selectedAudio = false">
                {{ 'action.close'|trans }}
            </button>
        </modal-component>

    </div>
</template>

<script>
    export default {
        name: 'DocumentsAction',
        props: {
            documents: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                showAudioModal: false,
                selectedAudio: null,
            };
        },
        methods: {
            handleClick(document) {
                if (document.type === 'audio') {
                    this.selectedAudio = document;
                    this.showAudioModal = true;
                } else {
                    // Let default <a :href> behavior handle download/open
                    window.open(document.original_url, '_blank');
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .documents-action {
        display: inline-flex;

        &__dropdown {
            display: inline-flex;
        }

        &__dropdown-label {
            display: inline-block;
            max-width: calc(100% - 16px);
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
            white-space: nowrap;
        }
    }
    .audio-modal-content {
        p {
            margin-bottom: 1rem;
        }

        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
</style>
